"use client"
import { useRef } from 'react';
import asmWorksEllipse from "@/assets/asmWorksEllipse.svg";
import ResourcesSection from './ResourcesSection/ResourcesSection';
import LevelUpAndTrustSection from './LevelUpAndTrustSection/LevelUpAndTrustSection';
import { motion, useInView } from 'framer-motion';
import Button from './global-component/DatasheetButtons';
import Image from 'next/image';


const AttackSurfaceManagement = ({ blok }) => {
  const levelUpRef = useRef(null);

  const handleScrollToLevelUp = () => {
    levelUpRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };


  const ref1 = useRef(null);
  const ref2 = useRef(null);
  const ref3 = useRef(null);
  const ref4 = useRef(null);
  const ref5 = useRef(null);
  const ref6 = useRef(null);
  const ref7 = useRef(null);
  const ref8 = useRef(null);

  const isInView1 = useInView(ref1, { once: true, margin: "-100px" });
  const isInView2 = useInView(ref2, { once: true, margin: "-100px" });
  const isInView3 = useInView(ref3, { once: true, margin: "-100px" });
  const isInView4 = useInView(ref4, { once: true, margin: "-100px" });
  const isInView5 = useInView(ref5, { once: true, margin: "-100px" });
  const isInView6 = useInView(ref6, { once: true, margin: "-100px" });
  const isInView7 = useInView(ref7, { once: true, margin: "-100px" });
  const isInView8 = useInView(ref8, { once: true, margin: "-100px" });

  const generateResourceUrls = (resourceSection) => {
    return resourceSection?.reduce((acc, item, index) => {
      acc[`resourceUrl${index + 1}`] = item.url?.cached_url;
      acc[`title${index + 1}`] = item.title;
      acc[`description${index + 1}`] = item.description;
      acc[`imageFilename${index + 1}`] = item.image?.filename;
      return acc;
    }, {});
  };

  const resourceUrls = generateResourceUrls(blok.resource_section);

  const handleDashboardClick = () => {
    window.open(blok?.DatasheetCta?.[0]?.asset?.filename, "_blank");
  };
  return (
    <>
      <div className='bg-asmPageTopBG w-full' style={{
        backgroundSize: "cover", // Ensure the image covers the entire section
        backgroundPosition: "center", // Center the background image
        backgroundxeat: "repeat", // Prevent repeating the background
        margin: 'auto'
      }}>
        <div className="relative min-h-[1000px] flex flex-col items-center py-8 max-w-[1920px] m-auto">
          {/* Header Section */}
          <div className="font-aileron pt-32 pb-[58px] lg:pb-32 text-center font-bold">
            <h2 className="bg-custom-radial bg-clip-text text-transparent text-[48px] lg:text-[80px]">
              {blok.titleText1}
            </h2>
            <div className="mt-4 text-[18px] w-[86%] m-auto lg:w-full lg:text-[32px] font-normal">
              {blok.titleText2}
            </div>
            <div className="mt-6 flex justify-center gap-6">
              <button onClick={handleScrollToLevelUp} className="font-aileron text-[18px] lg:text-[24px] font-normal bg-[#5A27E7] text-white px-6 py-2 rounded-[4px] hover:bg-[#483889] lg:w-[255px] lg:h-[64px]">
                {blok.btnText1}
              </button>
            </div>
          </div>

          {/* Main Content Section */}
          <div className="flex flex-col lg:flex-row lg:justify-center gap-[35px] lg:gap-[52px] max-w-7xl mx-auto z-20">
            {/* Left Column (Main Image) */}
            <div ref={ref1} className="lg:min-w-[50%] lg:max-w-[50%]">
              <motion.div
                initial={{ opacity: 0, x: -100 }}
                animate={isInView1 ? { opacity: 1, x: 0 } : {}}
                transition={{ duration: 0.5, delay: 0.2 }}
                className="">
                <img src={blok.mainImage1.filename} className='w-full object-contain px-[16px] lg:px-0' />
              </motion.div>
            </div>

            {/* Right Column (Full Image of Diagram) */}
            <div className="flex-1 mt-10 lg:mt-0">

              {/* Description */}
              <h2 className="flex justify-center text-center lg:text-left lg:flex lg:justify-start font-aileron text-[28px] lg:text-[48px]
               !font-bold bg-custom-radial bg-clip-text text-transparent mb-4 -mt-10">
                {blok.contentText1}
              </h2>
              <p className="font-aileron text-[16px] lg:text-[18px] lg:mb-6 w-[80%] lg:w-[90%] mx-auto mb-2 lg:m-0 text-center lg:text-start">
                {blok.contentText2}
              </p>
              <p className="font-aileron text-[16px] lg:text-[18px] lg:mb-6 w-[80%] lg:w-[90%] mx-auto mb-6 lg:m-0 text-center lg:text-start">
                {blok.contentText3}
              </p>
              <div className="flex justify-center items-center lg:justify-start">
                <Button title={blok?.DatasheetCta?.[0]?.text} onClick={handleDashboardClick} />
              </div>
            </div>
          </div>
          {/* <div className='absolute top-[53%]'>
            <img src={asmCurve} />
          </div> */}
        </div>
      </div>

      <div ref={ref2} className='relative min-h-[1000px] mt-0 m-auto z-0 bg-asmPageMiddleBG flex flex-col items-center ' style={{
        backgroundSize: "cover", // Ensure the image covers the entire section
        backgroundPosition: "center", // Center the background image
        backgroundRepeat: "no-repeat", // Prevent repeating the background
        // maxWidth: 1920,
        margin: 'auto'
      }}>
        <div style={{
          backgroundSize: "cover", // Ensure the image covers the entire section
          backgroundPosition: "center", // Center the background image
          backgroundRepeat: "no-repeat", // Prevent repeating the background
          // maxWidth: 1920,
          margin: 'auto'
        }}
          className='flex flex-col items-center w-full'
        >
          <div className='flex justify-center items-center flex-col w-full'>
            <h1 className='flex justify-center lg:block font-aileron 
          bg-custom-radial bg-clip-text text-transparent text-[28px] lg:text-[48px] 
          font-bold mt-4 mb-4 lg:mb-0 max-w-7xl'>{blok.contentText4}</h1>
            <div className='font-aileron flex justify-center items-center
            text-center text-[16px] lg:text-[18px] mx-auto max-w-7xl px-4'>{blok.contentText5}
            </div>
            <motion.div initial={{ opacity: 0, y: 50 }}
              animate={isInView2 ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.5, delay: 0.2 }} className='flex justify-center items-center mt-6 w-[100%] py-10 lg:pb-44 xl:pb-44 2xl:pb-96 bg-asmCurve px-4 lg:px-0' style={{
                backgroundSize: "100%", // Ensure the image covers the entire section
                backgroundPositionY: "bottom", // Center the background image
                backgroundRepeat: "no-repeat", // Prevent repeating the background
                // maxWidth: 1920,
                margin: 'auto'
              }}>
              <div className='border-4 border-[#9d96bc] rounded-lg'>
                <img src={blok.mainImage2.filename} className='w-[100%] h-full lg:w-[979px] lg:h-[548px] max-w-[1920px]' />
              </div>
            </motion.div>
          </div>
          <div className='w-full flex flex-col items-center bg-cover bg-top'>
            <div className='text-center xl:text-left justify-center xl:justify-start max-w-7xl font-aileron bg-custom-radial bg-clip-text text-transparent text-[28px] lg:text-[64px] font-bold lg:mt-0 flex lg:block w-full px-4 xl:px-0'>
              How Does<br className='hidden xl:block' /> ASM Work?
            </div>
            <div ref={ref3} className=' max-w-7xl flex flex-col gap-10 items-start relative'>
              <motion.img
                initial={{ opacity: 0, x: -100 }}
                animate={isInView3 ? { opacity: 1, x: 0 } : {}}
                transition={{ duration: 0.5, delay: 0.2 }}
                src={"/images/asmWorksEllipse.svg"} className='lg:absolute lg:h-[615px] lg:w-[883px] z-20 lg:block hidden' />
              <div className='grid grid-cols-1 xl:grid-cols-2 relative z-20 max-w-7xl'>
                <div className='mt-10 xl:mt-10 xl:ml-48 xl:w-[60%] w-[90%] m-auto'>
                  <motion.img initial={{ opacity: 0, x: -100 }}
                    animate={isInView3 ? { opacity: 1, x: 0 } : {}}
                    transition={{ duration: 0.5, delay: 0.2 }} src={blok.contentImage1.filename} className='m-auto lg:m-0' />
                  <p className='text-[24px] flex justify-center lg:block lg:text-[30px] font-aileron font-bold bg-custom-radial bg-clip-text text-transparent'>{blok.contentText6}</p>
                  <p className='text-[18px] flex justify-center lg:block lg:text-[24px] font-aileron font-bold text-center md:text-left'>{blok.contentText10}</p>
                  <p className='text-[16px] flex justify-center text-center lg:text-start lg:block lg:text-[18px] font-lato'>{blok.contentText14}</p>
                </div>
                <div className='mt-10 xl:mt-8  xl:w-[60%] w-[90%] m-auto'>
                  <motion.img initial={{ opacity: 0, x: -100 }}
                    animate={isInView3 ? { opacity: 1, x: 0 } : {}}
                    transition={{ duration: 0.5, delay: 0.2 }} src={blok.contentImage2.filename} className='m-auto lg:m-0' />
                  <p className='text-[24px] flex justify-center lg:block lg:text-[30px] font-aileron font-bold bg-custom-radial bg-clip-text text-transparent'>{blok.contentText7}</p>
                  <p className='text-[18px] flex justify-center lg:block lg:text-[24px] font-aileron font-bold text-center  md:text-left'>{blok.contentText11}</p>
                  <p className='text-[16px] flex justify-center lg:block text-center lg:text-start lg:text-[18px] font-lato'>{blok.contentText15}</p>
                </div>
              </div>
              <div ref={ref4} className='grid grid-cols-1 xl:grid-cols-2 max-w-7xl relative z-20'>
                <div className='mt-10  xl:-ml-6  xl:mt-0 xl:w-[60%] w-[90%] m-auto'>
                  <motion.img initial={{ opacity: 0, x: -100 }}
                    animate={isInView4 ? { opacity: 1, x: 0 } : {}}
                    transition={{ duration: 0.5, delay: 0.2 }} src={blok.contentImage3.filename} className='m-auto lg:m-0' />
                  <p className='text-[24px] flex justify-center lg:block lg:text-[30px] font-aileron font-bold bg-custom-radial bg-clip-text text-transparent'>{blok.contentText8}</p>
                  <p className='text-[18px] flex justify-center lg:block lg:text-[24px] font-aileron font-bold text-center  md:text-left'>{blok.contentText12}</p>
                  <p className='text-[16px] flex justify-center lg:block text-center lg:text-start lg:text-[18px] font-lato'>{blok.contentText16}</p>
                </div>
                <div className='mt-10  xl:-ml-14 xl:mt-2 xl:w-[60%] w-[90%] m-auto'>
                  <motion.img initial={{ opacity: 0, x: -100 }}
                    animate={isInView4 ? { opacity: 1, x: 0 } : {}}
                    transition={{ duration: 0.5, delay: 0.2 }} src={blok.contentImage4.filename} className='m-auto lg:m-0' />
                  <p className='text-[24px] flex justify-center lg:block lg:text-[30px] font-aileron font-bold bg-custom-radial bg-clip-text text-transparent'>{blok.contentText9}</p>
                  <p className='text-[18px] flex justify-center lg:block lg:text-[24px] font-aileron font-bold text-center  md:text-left'>{blok.contentText13}</p>
                  <p className='text-[16px] flex justify-center lg:block text-center lg:text-start lg:text-[18px] font-lato'>{blok.contentText17}</p>
                </div>

              </div>

            </div>
          </div>
          <div ref={ref5} className='flex  flex-wrap justify-center items-center text-center mt-10 lg:p-10'>
            <div className='flex flex-wrap gap-10 justify-center items-center text-start xl:h-[521px] xl:w-[1496px] w-[95%] m-auto lg:m-0 bg-[#FAF9FE] rounded-[20px] xl:py-20'>
              <motion.img initial={{ opacity: 0, x: -100 }}
                animate={isInView5 ? { opacity: 1, x: 0 } : {}}
                transition={{ duration: 0.5, delay: 0.2 }} src={blok.contentImage5.filename} className='lg:h-[362px] lg:w-[509px] h-[270px] m-auto mb-4 lg:m-0' />
              <div className='xl:w-[40%] w-[100%] m-auto lg:m-0 text-center lg:text-start px-4 xl:px-0'>
                <h6 className='font-aileron bg-custom-radial bg-clip-text text-transparent text-[24px] lg:text-[48px] font-bold'>{blok.contentText18}</h6>
                <p className='font-lato text-[16px] lg:text-[18px] mt-2 lg:mt-10'>{blok.contentText19}</p>
              </div>
            </div>
          </div>
        </div>
        <div className='max-w-7xl m-auto -mb-10 lg:min-h-[1700px]' style={{
          backgroundSize: "cover", // Ensure the image covers the entire section
          backgroundPosition: "center", // Center the background image
          backgroundRepeat: "no-repeat", // Prevent repeating the background
          // maxWidth: 1920,
          margin: 'auto'
        }}>
          <div ref={ref6} className='lg:flex justify-center items-center text-center p-4 lg:p-10'>
            <div className='lg:flex flex-col lg:flex-row gap-10 justify-center text-start lg:py-20'>
              <div className='lg:w-[45%] text-center lg:text-start  m-auto lg:m-0'>
                <h6 className='font-aileron bg-custom-radial bg-clip-text text-transparent text-[24px] lg:text-[48px] font-bold'>{blok.contentText20}</h6>
                <p className='font-lato text-[16px] lg:text-[18px] mt-2 lg:mt-10'>{blok.contentText21}</p>
              </div>
              <motion.img initial={{ opacity: 0, x: 100 }}
                animate={isInView6 ? { opacity: 1, x: 0 } : {}}
                transition={{ duration: 0.5, delay: 0.2 }} src={blok.contentImage6.filename} className='lg:h-[283px] lg:w-[666px] w-[100%] mt-10 lg:mt-0' />
            </div>
          </div>
          <div className='flex flex-col items-center text-center justify-center lg:mb-10 p-4 lg:px-0'>
            <h6 className='font-aileron bg-custom-radial bg-clip-text text-transparent text-[24px] lg:text-[48px] font-bold mb-4 lg:mb-0'>{blok.contentText22}</h6>
            <p className='font-lato text-[16px] lg:text-[18px]'>{blok.contentText23}</p>
            <div ref={ref7} className='w-[300px] lg:h-[500px] lg:w-[500px] mt-10 rounded-lg'> <motion.img
              initial={{ opacity: 0, x: -100 }}
              animate={isInView7 ? { opacity: 1, x: 0 } : {}}
              transition={{ duration: 0.5, delay: 0.2 }}
              src={blok.contentImage7.filename} /> </div>
            <div className='mb-10 w-full'>
              <div className='flex justify-center mb-10'>
                <h6 className='font-aileron bg-custom-radial bg-clip-text text-transparent text-[28px] lg:text-[48px] font-bold mt-20'>{blok.contentText24}</h6>
              </div>
              <div ref={ref8} className='grid space-y-10 lg:space-y-0 lg:grid-cols-3 w-[100%] m-auto lg:w-full gap-4 md:gap-[50px]'>
                <motion.div initial={{ opacity: 0, x: -100 }}
                  animate={isInView8 ? { opacity: 1, x: 0 } : {}}
                  transition={{ duration: 0.5, delay: 0.2 }} className="relative flex-1 p-[4px] rounded-lg bg-gradient-to-b from-[#D259A6]/80 to-[#48398C]/50">
                  {/* Inner content div */}
                  <div className="h-full w-full bg-ASMBenefitsBg rounded-lg flex flex-col justify-center items-center text-center py-10">
                    <img src={blok.contentImage8.filename} className="h-[156px] w-[155px]" />
                    <p className="font-lato text-[24px] text-[#49378F] font-bold -mt-4 mb-2">{blok.contentText25}</p>
                    <p className="text-[18px] font-lato w-[80%]">{blok.contentText26}</p>
                  </div>
                </motion.div>

                <motion.div
                  initial={{ opacity: 0, y: -50 }}
                  animate={isInView8 ? { opacity: 1, y: 0 } : {}}
                  transition={{ duration: 0.5, delay: 0.2 }}
                  className="relative flex-1 p-[4px] rounded-lg bg-gradient-to-b from-[#D259A6]/80 to-[#48398C]/50">
                  {/* Inner content div */}
                  <div className="h-full w-full bg-ASMBenefitsBg rounded-lg flex flex-col justify-center items-center text-center py-10">
                    <img src={blok.contentImage9.filename} className='h-[128px] w-[128px] mb-6' />
                    <p className='font-lato text-[24px] text-[#49378F] font-bold -mt-4 mb-2'>{blok.contentText27}</p>
                    <p className='text-[18px] font-lato w-[80%]'>{blok.contentText28}</p>
                  </div>
                </motion.div>

                <motion.div
                  initial={{ opacity: 0, x: 100 }}
                  animate={isInView8 ? { opacity: 1, x: 0 } : {}}
                  transition={{ duration: 0.5, delay: 0.2 }}
                  className="relative flex-1 p-[4px] rounded-lg bg-gradient-to-b from-[#D259A6]/80 to-[#48398C]/50">
                  {/* Inner content div */}
                  <div className="h-full w-full bg-ASMBenefitsBg rounded-lg flex flex-col justify-center items-center text-center py-10">
                    <img src={blok.contentImage10.filename} className='h-[128px] w-[128px] mb-6' />
                    <p className='font-lato text-[24px] text-[#49378F] font-bold -mt-4 mb-2'>{blok.contentText29}</p>
                    <p className='text-[18px] font-lato w-[80%]'>{blok.contentText30}</p>
                  </div>
                </motion.div>
              </div>
            </div>
          </div>
        </div>

        <div className='bg-[#EFEBFB] w-full'>
          <div className='space-y-6'>
            <ResourcesSection
              calenderIcon={blok.calenderIcon.filename}
              blok={blok}
            />
            <div>
              <LevelUpAndTrustSection certiReqd={true} blok={blok} levelUpRef={levelUpRef}/>
            </div>
          </div>
          {/* <Footer blok={blok} /> */}
        </div>
      </div>
    </>
  );
};

export default AttackSurfaceManagement;
